import { apiFetch } from "./http"
import { mockClient } from "./mockClient"
import type { BillingUsageSummary, StripePlanCatalog } from "../types"

function authHeaders(token?: string | null): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function fetchBillingPlans(demo: boolean): Promise<StripePlanCatalog> {
  if (demo) {
    return mockClient.getBillingPlans(true)
  }
  return apiFetch<StripePlanCatalog>("/api/billing/plans")
}

export async function fetchBillingUsage(demo: boolean, token?: string | null): Promise<BillingUsageSummary> {
  if (demo) {
    return mockClient.getBillingUsage(true)
  }
  return apiFetch<BillingUsageSummary>("/api/billing/usage", { headers: authHeaders(token) })
}

export async function changeBillingPlan(planSlug: string, demo: boolean, token?: string | null): Promise<BillingUsageSummary> {
  if (demo) {
    return mockClient.updateBillingPlan(planSlug)
  }
  return apiFetch<BillingUsageSummary>("/api/billing/plan", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ plan_slug: planSlug }),
  })
}

export async function updateBillingAddons(addonSlugs: string[], demo: boolean, token?: string | null): Promise<BillingUsageSummary> {
  if (demo) {
    return mockClient.updateBillingAddons(addonSlugs)
  }
  return apiFetch<BillingUsageSummary>("/api/billing/addons", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ addon_slugs: addonSlugs }),
  })
}

export async function createBillingCheckoutSession(
  planSlug: string,
  demo: boolean,
  token?: string | null,
): Promise<string> {
  if (demo) {
    return "https://checkout.stripe.com/c/pay/demo"
  }
  const response = await apiFetch<{ url: string }>("/api/billing/checkout", {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify({ plan_slug: planSlug }),
  })
  return response.url
}

export async function createBillingPortalSession(demo: boolean, token?: string | null): Promise<string> {
  if (demo) {
    return mockClient.createBillingPortalSession()
  }
  const response = await apiFetch<{ url: string }>("/api/billing/portal", {
    method: "POST",
    headers: authHeaders(token),
  })
  return response.url
}
